<template>
	<div id="app">
		<router-view></router-view>
	</div>
</template>

<script>
	import cookie from './libs/cookie'
	export default {
		name: 'app',
		beforeMount(){
			var xiaoxiongChannel = [731100001,731100002,731300001,731300003]
			var channelid = this.querystr('channelid')||cookie.get('channelid')||0;
			if(xiaoxiongChannel.indexOf(channelid-0) != -1){
				cookie.set('isxiaoxiong', true, {
					domain: 'qxiu.com',
					encode: true
				})
				cookie.set('oemid',43, {domain: 'qxiu.com',encode: true})
				sessionStorage.setItem('isxiaoxiong',true)
			}else{
				cookie.set('isxiaoxiong', false, {
					domain: 'qxiu.com',
					encode: true
				})
				sessionStorage.setItem('isxiaoxiong',false)
			}
		},
		methods:{
			querystr(name) {
				var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
				var r = window.location.search.substr(1).match(reg);
				if(r != null) return unescape(r[2]);
				return null;
			},
		}
	}
</script>

<style>
	* {
		margin: 0;
		padding: 0;
		text-decoration: none;
	}
	
	body {
		font-size: 10px;
		background: #e9e9e9;
	}
	
	ul {
		list-style: none;
	}
	
	i {
		font-style: normal;
	}
	
	#app {
		margin: 0 auto;
		max-width: 750px;
		font-family: "microsoft yahei", 'Avenir', Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
	}
	
	
@font-face {font-family: "iconfont";
  src: url('font/iconfont.eot'); /* IE9*/
  src: url('font/iconfont.eot') format('embedded-opentype'), /* IE6-IE8 */
  url('font/iconfont.woff') format('woff'),
  url('font/iconfont.ttf') format('truetype'), /* chrome, firefox, opera, Safari, Android, iOS 4.2+*/
  url('font/iconfont.svg') format('svg'); /* iOS 4.1- */
}

.iconfont {
  font-family:"iconfont" !important;
  font-size:16px;
  font-style:normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.icon-ttpodicon:before { content: "\e667"; }

.icon-rendaiwaiquan:before { content: "\e610"; }

.icon-xiugaizhuanhuan:before { content: "\e61d"; }

.icon-iconfonticonfontzhifubao:before { content: "\e65c"; }

.icon-right:before { content: "\e883"; }

.icon-rmb:before { content: "\e64e"; }

.icon-weixinzhifu:before { content: "\e620"; }

.icon-chenggongtips:before { content: "\e655"; }

.icon-guanzhu1:before { content: "\e624"; }

.icon-guanzhu:before { content: "\e608"; }

.icon-wode1:before { content: "\e60b"; }

.icon-wode:before { content: "\e601"; }

.icon-shouji:before { content: "\e6bb"; }

.icon-xiugaimima:before { content: "\e630"; }

.icon-QQ:before { content: "\e633"; }

.icon-sousuo:before { content: "\e967"; }

.icon-weibo:before { content: "\e605"; }

.icon-xiangji:before { content: "\e603"; }

.icon-shouyexian:before { content: "\e67d"; }

.icon-shouye:before { content: "\e63a"; }

.toast{
    width: 5.5rem;
    position: absolute;
    top: 45%;
    text-align: center;
    left: 50%;
    margin-left: -3rem;
    padding: 0.5rem 1rem;
    border-radius: 0.5rem;
    color: #fff;
    background: rgba(0,0,0,0.5);
    z-index: 1000;
}
</style>


// WEBPACK FOOTER //
// App.vue?623471e0